import Model from '@/lib/data/Model';

class FormData extends Model {
    static idProperty = 'id';

    fields = [
        'id',
        'form_id',
        'visit_id',
        'representative_id',
        'customer_id',
        'form_name',
        'address',
    ];

    constructor(data) {
        super(data);
        this.init();
    }
}

export default FormData;
